<template>
  <v-card elevation="0">
    <v-card-text>
      <base-subheading :subheading="$t('dashboard.reliabilityResume')" />

      <template v-if="list && list.list">
        <v-card color="secondary" dark class="mb-4">
          <v-card-title
            :class="$vuetify.breakpoint.mdAndUp ? '' : 'subtitle-1'"
          >
            {{ $t("dashboard.theLastReliability") }} {{ lastDateAgo }}
          </v-card-title>
        </v-card>

        <v-card color="secondary" dark class="mb-4">
          <v-card-subtitle class="d-flex text-capitalize"
            >{{ $t("dashboard.meanTimeBetweenFailure") }} <v-spacer></v-spacer>
            <v-tooltip bottom color="primary">
              <template v-slot:activator="{ on, attrs }">
                <v-icon dark v-bind="attrs" v-on="on">mdi-information</v-icon>
              </template>
              <span>
                {{ $t("dashboard.moreMeanTimeBetweenFailure") }}
              </span>
            </v-tooltip>
          </v-card-subtitle>

          <v-card-title class="mt-0 pt-0">
            {{
              totalFailures > 1
                ? isNaN(running.meanTimeInHours)
                  ? "The equipment does not have running register"
                  : `${parseFloat(
                      running.meanTimeInHours / totalFailures
                    ).toFixed(2)} ${$t("dashboard.hours")}`
                : "  There is no reliability information yet"
            }}

            <v-tooltip bottom color="primary">
              <template v-slot:activator="{ on, attrs }">
                <v-icon dark v-bind="attrs" v-on="on">
                  mdi-information-variant
                </v-icon>
              </template>
              <span>MTBF = Operating Time (hours) / Number of Failures</span>
            </v-tooltip>
          </v-card-title>
        </v-card>

        <v-card color="secondary" dark class="mb-4">
          <v-card-subtitle class="d-flex">
            {{ $t("dashboard.mechanicalAvailability") }} <v-spacer></v-spacer>
            <v-tooltip bottom color="primary">
              <template v-slot:activator="{ on, attrs }">
                <v-icon dark v-bind="attrs" v-on="on">mdi-information</v-icon>
              </template>
              <span>
                {{ $t("dashboard.moreMechanicalAvailability") }}
              </span>
            </v-tooltip></v-card-subtitle
          >
          <v-card-title class="mt-0 pt-0">
            {{ mechanicalAvailability }}
            <v-tooltip bottom color="primary">
              <template v-slot:activator="{ on, attrs }">
                <v-icon dark v-bind="attrs" v-on="on"
                  >mdi-information-variant</v-icon
                >
              </template>
              <span
                >Availability % = {Uptime (hrs.) / [Total Available Time (hrs.)
                – Idle Time (hrs.)]} x 100</span
              >
            </v-tooltip>
          </v-card-title>
        </v-card>
        <v-card color="secondary" dark class="mb-4">
          <v-card-subtitle class="d-flex"
            >{{ $t("dashboard.utilizationTime") }} <v-spacer></v-spacer>
            <v-tooltip bottom color="primary">
              <template v-slot:activator="{ on, attrs }">
                <v-icon dark v-bind="attrs" v-on="on">mdi-information</v-icon>
              </template>
              <span>
                {{ $t("dashboard.moreUtilizationTime") }}
              </span>
            </v-tooltip></v-card-subtitle
          >

          <v-card-title class="mt-0 pt-0"
            >{{ utilizationTime
            }}<v-tooltip bottom color="primary">
              <template v-slot:activator="{ on, attrs }">
                <v-icon dark v-bind="attrs" v-on="on"
                  >mdi-information-variant</v-icon
                >
              </template>
              <span
                >Utilization Time (percentage) = [Total Available Time (hrs.) –
                Idle Time (hrs.)] / Total Available Time (hrs.)] × 100</span
              >
            </v-tooltip></v-card-title
          >
        </v-card>
        <v-card color="secondary" dark class="mb-4">
          <v-card-subtitle class="d-flex">
            {{ $t("dashboard.operatingTime") }}<v-spacer></v-spacer>
            <v-tooltip bottom color="primary">
              <template v-slot:activator="{ on, attrs }">
                <v-icon dark v-bind="attrs" v-on="on">mdi-information</v-icon>
              </template>
              <span> {{ $t("dashboard.moreOperatingTime") }} </span>
            </v-tooltip></v-card-subtitle
          >

          <v-card-title class="mt-0 pt-0"
            >{{ list.timeFormat(running.totalTime).time }}
            {{
              $t(`dashboard.${list.timeFormat(running.totalTime).unit}`)
            }}</v-card-title
          > </v-card
        ><v-card color="secondary" dark>
          <v-card-subtitle class="d-flex"
            >{{ $t("dashboard.totalDowntime") }}<v-spacer></v-spacer>
            <v-tooltip bottom color="primary">
              <template v-slot:activator="{ on, attrs }">
                <v-icon dark v-bind="attrs" v-on="on">mdi-information</v-icon>
              </template>
              <span>
                {{ $t("dashboard.moreTotalDowntime") }}
              </span>
            </v-tooltip>
          </v-card-subtitle>

          <v-card-title class="mt-0 pt-0">
            {{ totalDownTime }} {{ $t("dashboard.hours") }}</v-card-title
          >
        </v-card>
      </template>
      <v-card v-else color="secondary" dark class="mb-4">
        <v-card-title :class="$vuetify.breakpoint.mdAndUp ? '' : 'subtitle-1'">
          There is no reliability information yet
        </v-card-title>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
import realiabilityCalc from "@/mixins/reliabilityCalcMixin";
export default {
  mixins: [realiabilityCalc]
};
</script>

<style scoped>
.v-card__subtitle {
  margin-bottom: 0px !important;
  padding-bottom: 0px !important;
}
</style>
